import React from "react";
import * as S from "./styles";

type HeroBannerProps = {
  title: string;
  subtitle: string;
  buttonLabel?: string;
  backgroundImage?: string;
  onButtonClick?: () => void;
};

const HeroBanner: React.FC<HeroBannerProps> = ({
  title,
  subtitle,
  buttonLabel,
  backgroundImage,
  onButtonClick,
}) => {
  return (
    <S.BannerContainer>
      <S.ContentContainer>
        <S.Title>{title}</S.Title>
        <S.Subtitle>{subtitle}</S.Subtitle>
        <S.StyledButton onClick={onButtonClick}>{buttonLabel}</S.StyledButton>
      </S.ContentContainer>

      <S.ImageContainer>
        <S.StyledImage src={backgroundImage} alt="Dashboard illustration" />
      </S.ImageContainer>
    </S.BannerContainer>
  );
};

export default HeroBanner;
